export default __webpack_public_path__ + "static/media/home.e5d45726.png";